import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getInfoRestaurantApi } from '~/apis/home'
import { MERCHANT_TYPE } from '~/constants/restaurant'
import { defaultCurrency, loadingStates, paymentTypes } from '~/config/constant'
import { DEFAULT_FORMAT_PRICE } from '~/constants/currency'

const initialState = {
  data: {
    restaurantId: null,
    restaurantSlug: '',
    restaurantName: '',
    tableId: null,
    tableUid: '',
    tableName: '',
    vatPercent: null,
    serviceRate: null,
    menuExcludesVAT: null,
    homeTemplateId: null,
    extraFeatures: [],
    logoTopPage: null,
    logoHomePage: null,
    line_page_url: '',
    supportLang: [],
    theme: 'default',
    currency: defaultCurrency,
    allow_order: true,
    capichi_delivery_following: false,
    merchant_type: MERCHANT_TYPE.RESTAURANT,
    paymentType: paymentTypes.pay_after_receive,
    externalPartner: '',
    number_of_people: null,
    food_court_id: null, // Một nhà hàng có thể thuộc một food court nào đó
    food_court_slug: '',
    order_code: '',
    google_map_url: '',
    tripadvisor_url: '',
    instagram_url: '',
    timezone: '',
    banner_promote_delivery: [],
    separate_order: false,
    phone: '',
    food_court_partner: '',
    buffet_requests_time: [],
    linkage_requests_time: [],
    price_format: DEFAULT_FORMAT_PRICE,
    country: '',
  },
  loading: 'idle',
  error: null,
}

export const fetchDetailRestaurant = createAsyncThunk(
  'restaurant/fetchDetail',
  getInfoRestaurantApi,
)

export const restaurantSlice = createSlice({
  name: 'restaurant',
  initialState,
  reducers: {
    saveDataRestaurant: (state, action) => {
      state.data = { ...state.data, ...action.payload }
      state.error = null
    },
    addBuffetRequestTime: (state, action) => {
      state.data.buffet_requests_time.push(action.payload)
    },
    removeBuffetRequestTime: (state, action) => {
      const servingTime = action.payload
      state.data.buffet_requests_time = state.data.buffet_requests_time.filter(
        (time) => time.serving_ended_at !== servingTime,
      )
    },
    removeLinkageRequestTime: (state, action) => {
      const servingTime = action.payload
      state.data.linkage_requests_time = state.data.linkage_requests_time.filter(
        (time) => time.serving_ended_at !== servingTime,
      )
    },
  },
  extraReducers: {
    [fetchDetailRestaurant.pending]: (state) => {
      state.loading = loadingStates.pending
      state.error = null
    },
    [fetchDetailRestaurant.fulfilled]: (state, action) => {
      state.loading = loadingStates.success
      state.data = action.payload
      state.error = null
    },
    [fetchDetailRestaurant.rejected]: (state, action) => {
      state.loading = loadingStates.error
      state.error = action.payload?.data
    },
  },
})

export const {
  saveDataRestaurant,
  addBuffetRequestTime,
  removeBuffetRequestTime,
  removeLinkageRequestTime,
} = restaurantSlice.actions

export const selectRestaurant = (state) => {
  return state.restaurant.data
}

export const selectErrorRestaurant = (state) => state.restaurant.error

export default restaurantSlice.reducer
